module.exports = __webpack_public_path__ + "img/titlezh.9ae6caae.png";